import React, { Component } from "react";
import OOLogo from "./../../assets/OOLogo.svg";
import trivvyLogo from "./../../assets/trivvy/trivvy-logo-img.png";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import trivvyLogoTxt from "./../../assets/trivvy/trivvyTextLogo.png";

import { isTrivvyProduct, TRIVIA_DESCRIPTION } from "../../utils/constants";

class Logo extends Component {
  constructor(props) {
    super(props);
  }

  checkCompanyLogo = () => {
    // console.log('this props --- ', this.props)
    if (this.props && this.props != undefined) {
      if (this.props.user && this.props.user.organizationId) {
        let { organizationId } = this.props.user;
        // console.log('org exists ----- ', organizationId)

        if (
          organizationId &&
          organizationId.whiteLabel &&
          organizationId.whiteLabel.logo &&
          organizationId.whiteLabel.logo.url != ""
        ) {
          return organizationId.whiteLabel.logo.url;
        }
      }
    }
    let { organizationId } = this.props.user;
    // console.log('ooLOGO --- ', OOLogo)
    if (organizationId && (organizationId.isSignedUpFromTrivvyWebsite || isTrivvyProduct)) {
      return trivvyLogoTxt;
    } else {
      return OOLogo;
    }
  };

  //   <div onClick={() => this.goToTrivvy()} className="pt-3 trivvy-logo-container-itm">
  //   <img src={trivvyLogo} className="sidebar-trivvy-logo-img" />
  //   <span
  //     className="sidebar-trivvy-logo-txt"
  //     data-tip={TRIVIA_DESCRIPTION}
  //   >
  //     Trivvy
  //   </span>

  //   <ReactTooltip />
  // </div>

  render() {
    let imageUrl = this.checkCompanyLogo();
    let isSignedUpFromTrivvyWebsite = false;
    if (this.props.user && this.props.user.organizationId) {
      isSignedUpFromTrivvyWebsite = this.props.user.organizationId
        .isSignedUpFromTrivvyWebsite;
    } else {
      isSignedUpFromTrivvyWebsite = window.location.href.includes(
        "fromTrivvy=true"
      );
    }
    return (
      <div
        className={`text-center ${
          this.props.customClass
            ? this.props.customClass
            : isSignedUpFromTrivvyWebsite
            ? "logoContainer"
            : "logoContainer"
        }`}
      >
        {this.props.renderForExport ? (
          <img
            src={imageUrl + "?not-from-cache-please"}
            crossOrigin="anonymous"
            alt="Logo"
            className={
              this.props.customClass
                ? this.props.customClass + " logoImage"
                : "logoImage"
            }
          />
        ) : isSignedUpFromTrivvyWebsite ? (
          <span>
            {imageUrl ? (
              <img
                src={imageUrl}
                alt="Logo"
                className={
                  this.props.customClass
                    ? this.props.customClass + " logoImage"
                    : "logoImage"
                }
              />
            ) : (
              <span
                className="sidebar-trivvy-logo-txt"
                data-tip={TRIVIA_DESCRIPTION}
              >
                Trivvy
              </span>
            )}
          </span>
        ) : (
          <img
            src={imageUrl}
            alt="Logo"
            className={
              this.props.customClass
                ? this.props.customClass + " logoImage"
                : "logoImage"
            }
          />
        )}
      </div>
    );
  }
}

// export class NavBarLogo extends Component {
//     render() {
//         return (
//             <img
//                 src={OOLogo}
//                 alt="Logo"
//                 className="align-self-center"
//                 style={{ height: '30px',marginLeft:'15px'}}
//             />
//         );
//     }
// }

// module.export = {
//     Logo,
//     NavBarLogo
// }
const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Logo);
